export default {
  warning: {
    summary: 'Unsupported material composition',
    details: 'The calculation of CCT Diagrams is currently limited to materials where the weight percentage of all elements is smaller than {threshold}.',
  },
};
